import course from '@/api/course';

import { CHANGE_DATE, FETCH_DAILY_COURSES } from './types';

export default {
    [CHANGE_DATE]({ commit, dispatch }, payload) {
        commit(CHANGE_DATE, payload);
        dispatch(FETCH_DAILY_COURSES, payload);
    },
    [FETCH_DAILY_COURSES]({ commit }, payload) {
        course.daily(payload.date)
            .then((resp) => {
                commit(FETCH_DAILY_COURSES, resp);
            });
    },
};



// WEBPACK FOOTER //
// ./src/store/calendar/actions.js